import { useCallback, useState } from 'react';

const useSticky = () => {
  const [isSticky, setSticky] = useState(false);

  const updateStickyState = useCallback(
    ({ currentPosition, previousPosition }) => {
      if (currentPosition === 'inside' && previousPosition === 'above') {
        setSticky(false);
      }
      if (currentPosition === 'above' && previousPosition === 'inside') {
        setSticky(true);
      }
    },
    []
  );

  return {
    isSticky,
    updateStickyState
  };
};

export default useSticky;
